<app-aggregated-amount-item
  name="UM ホームページページビュー"
  icon="./assets/universal_music.png"
  amount="{{ (umhpPageview$ | async)?.units }}"
  unit="ページビュー数"
  [rate]="(umhpPageview$ | async)?.rate"
  [link]="(selectedArtist$ | async)?.umhpUrl"
  [hasAmount]="(umhpPageview$ | async)?.hasUnits"
  help="{{
    (selectedArtist$ | async)?.nameMain
  }} のページビュー数です。ページビュー数は選択期間内の合計数です。"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async"
></app-aggregated-amount-item>
